module.exports = __webpack_public_path__ + "static/img/hh4.911283cc.png";